import pluralize from 'pluralize';
import React from 'react';
import { BulkActionModal } from '~/components/bulk-action';
import { useApi, useWorkspace } from '~/contexts';
import AllocationSummary from './AllocationSummary';

export default function BulkDelete({ ids, onClose, onComplete }) {
  const { workspace } = useWorkspace();
  const api = useApi();

  return (
    <BulkActionModal
      title="Bulk Delete"
      variant="delete"
      onClose={onClose}
      onComplete={onComplete}
      onConfirm={() =>
        api.www
          .workspaces(workspace.id)
          .allocations()
          .bulkDelete(ids)
          .then((r) => r.data)
      }
      renderRow={AllocationSummary}>
      {`Are you sure you want to delete ${ids.length} ${pluralize('allocation', ids.length)}? This action cannot be undone.`}
    </BulkActionModal>
  );
}
